mutation CreateCallRailIntegration($input: CallRailIntegrationCreateInput!) {
    callRailIntegrationCreate(input: $input) {
        status
        callRailIntegration {
            isEnabledForUser
        }
    }
}
